/**
 *
 * Dashboard
 *
 */

import React, { Fragment } from "react"
import { connect } from "react-redux"
import { Helmet } from "react-helmet"
import { createStructuredSelector } from "reselect"
import { compose } from "redux"

import injectSaga from "utils/injectSaga"
import injectReducer from "utils/injectReducer"
import Layout from "components/Layout"
import WidgetResumen from "components/WidgetResumen"
import WidgetResponseRate from "components/WidgetResponseRate"
import CardBirthDay from "components/CardBirthDay"
import PendingSurveys from "components/PendingSurveys"
import CardWidget from "components/CardWidget"
import iconBars from "images/icon-bars.svg"
import emptyStateDashboard from "images/emptyStateDashboardLeader.svg"
import UserList from "components/UserList"

import {
  Button,
  List,
  Avatar,
  Empty,
  Spin,
  Divider,
  Modal,
  Input,
  Row,
} from "antd"
const { TextArea } = Input
import { get } from "lodash"
import "../index.less"
import "./index.less"
import moment from "moment"
import saga from "./saga"
import reducer from "./reducer"
import {
  getProfileLeaderWatcher,
  getDashboardWatcher,
  getTaskWatcher,
  submitFeedbackSurvey,
  dismissFeedbackSurvey,
} from "./actions"
import {
  makeSelectIsLoadingProfile,
  makeSelectProfileLeader,
  makeSelectDashboardData,
  makeSelectLoadingDashboard,
  makeSelectPendingSurveys,
} from "./selectors"
import {
  getItem,
  LOCAL_DASHBOARD_BIRTHDAY_CHECK,
  SHOWED_FEEDBACK_SURVEY,
  LOCAL_USER_EMAIL,
  LOCAL_COMPANY_NAME,
  LOCAL_ACTIVE_ROL_NAME,
  LOCAL_COMPANY_HUBSPOT,
  LOCAL_COMPANY_COUNTRY,
  LOCAL_USER_ID
} from "../../../utils/storage"
import { initializeSurvicateVisitor } from "../../../utils/survicate"
import { loadTexts, sanitize } from "../../../utils/i18n"

/* eslint-disable react/prefer-stateless-function */
export class Dashboard extends React.Component {
  intl = loadTexts("dashboard")
  state = {
    can_create_action_plan: false,
    measuresModalCreate: [],
    surveyStep: 1,
    surveyVisible: false,
    surveyResponse: { score: 0, comments: "" },
  }

  constructor(props) {
    super(props)
  }
  componentDidMount() {
    initializeSurvicateVisitor({
      user_id: LOCAL_USER_ID(),
      email: LOCAL_USER_EMAIL(),
      stage: process.env.APP_ENV,
      company: LOCAL_COMPANY_NAME(),
      role: LOCAL_ACTIVE_ROL_NAME(),
      hubspot: LOCAL_COMPANY_HUBSPOT(),
      user_country: LOCAL_COMPANY_COUNTRY(),
    })
    //window.wootric_survey_immediately = true // Shows survey immediately for testing purposes. TODO: Comment out for production.


    this.props.getProfileLeader()
    this.props.getDashboard()
  }

  emptyState = () => {
    const { dashboard, loading_dashboard, profile_leader } = this.props
    const meditions = get(dashboard, "measure_with_measure_metrics", [])
    const validateIfOneMeditionAndProgress =
      meditions.length === 1 && meditions[0].id_measure_status === 3
    const validateIfOneMeditionAndAnonymity =
      meditions.length === 1 && !meditions[0].anonymity
    let content = (
      <Empty
        style={{ color: "#828282", maxWidth: 515, margin: "50px auto" }}
        image={null}
        imageStyle={{ display: "none" }}
        description={
          <Fragment>
            <div>
              <img src={emptyStateDashboard} />
            </div>
            <span
              style={{ margin: "20px auto", fontSize: 16, display: "block" }}>
              <p>
                <b>¡No cuentas con resultados recientes!</b>
              </p>
            </span>
            <p>
              No cuentas con ninguna medición reciente o en curso con
              resultados. <br /> Acércate al área de Gestión del Talento para
              conocer cuando será la próxima medición.
            </p>
          </Fragment>
        }
      />
    )
    let type = 0
    let active = false
    // get(dashboard, 'measure_with_measure_metrics', []).length === 0 && get(dashboard, 'team', []).length === 0
    if (
      !loading_dashboard &&
      get(dashboard, "measure_with_measure_metrics", []).length === 0
    ) {
      type = 2
      active = true
    }

    if (
      !loading_dashboard &&
      get(dashboard, "measure_with_measure_metrics", []).length === 0 &&
      get(profile_leader, "team_leader", []).length === 0
    ) {
      type = 1
      active = true
    }

    if (!loading_dashboard && validateIfOneMeditionAndAnonymity) {
      content = this.renderEmptyAnonymite()
      active = true
    }

    if (!loading_dashboard && validateIfOneMeditionAndProgress) {
      content = this.renderEmptyProgress()
      active = true
    }

    return {
      active,
      type, // null,
      content,
    }
  }

  renderWidgetResponse = (measure) => {
    const data = {
      employees: measure.employees,
      recipients: measure.recipients,
      rate: {
        rate: measure.rate_division.rate,
        rate_color: measure.rate_division.rate_color,
        rate_visible: measure.rate_division.rate_visible,
      },
    }

    return (
      <div
        className="widgetReponseCustom"
        onClick={() => {
          this.props.history.push(
            `/reports/measure/${measure.survey_type}/${measure.id_measure}`
          )
        }}>
        <WidgetResponseRate
          title={
            measure.survey_type === 2 ? (
              <b>{this.intl.responseRateWidget.responseRate}</b>
            ) : (
              <span style={{ fontWeight: "normal" }}>
                <b>{this.intl.responseRateWidget.responseRate}:</b>
              </span>
            )
          }
          isLoading={false}
          data={data}
        />
      </div>
    )
  }

  renderEmptyProgress = () => {
    const { dashboard } = this.props
    const meditions = get(dashboard, "measure_with_measure_metrics", [])
    const currentMedition = meditions[0]
    const content = (
      <Empty
        style={{ color: "#828282", margin: "50px auto" }}
        image={null}
        imageStyle={{ display: "none" }}
        description={
          <Fragment>
            <div
              style={{
                textAlign: "left",
                maxWidth: 380,
                margin: "0 auto 40px",
              }}>
              {this.renderWidgetResponse(currentMedition)}
            </div>
            <span
              style={{ margin: "20px auto", fontSize: 16, display: "block" }}>
              <p>
                <b>
                  ¡No cuentas con resultados adicionales para tu equipo aún!
                </b>
              </p>
              <p style={{ fontSize: 14 }}>
                Actualmente hay una medición en curso:
              </p>
            </span>
            <div style={{ marginBottom: 20 }}>
              <p>
                {currentMedition.name} <Divider type="vertical" />
                <b>Fecha de inicio:</b>{" "}
                {moment(currentMedition.date_start).format("DD/MM/YY")}{" "}
                <Divider type="vertical" />
                <b>Fecha Fin:</b>{" "}
                {moment(currentMedition.date_end).format("DD/MM/YY")}
              </p>
            </div>
            <p>
              Una vez que el administrador haya oficializado los resultados de
              la medición te lo{" "}
              <b>
                notificaremos <br /> por correo
              </b>{" "}
              para que puedas visualizarlos en la plataforma.
            </p>
          </Fragment>
        }
      />
    )

    return content
  }

  renderEmptyAnonymite = () => {
    const content = (
      <Empty
        style={{ color: "#828282", maxWidth: 500, margin: "50px auto" }}
        image={null}
        imageStyle={{ display: "none" }}
        description={
          <Fragment>
            <div>
              <img src={emptyStateDashboard} />
            </div>
            <span
              style={{ margin: "20px auto", fontSize: 16, display: "block" }}>
              <p>
                <b>{this.intl.generalView.emptyStateResults.title}</b>
              </p>
            </span>
            <p>{this.intl.generalView.emptyStateResults.description}</p>
          </Fragment>
        }
      />
    )

    return content
  }
  changeSurveyStep = (step) => {
    this.setState({ ...this.state, surveyStep: step })
  }
  saveSurveyScore = (score) => {
    let surveyResponse = this.state.surveyResponse
    surveyResponse.score = score
    this.setState({ ...this.state, surveyResponse })
    this.changeSurveyStep(2)
  }
  saveSurveyComments = (comments) => {
    let surveyResponse = this.state.surveyResponse
    surveyResponse.comments = comments
    this.setState({ ...this.state, surveyResponse })
    this.changeSurveyStep(3)
  }
  handleSurveyCommentsChange = (e) => {
    let surveyResponse = this.state.surveyResponse
    surveyResponse.comments = e.target.value
    this.setState({ ...this.state, surveyResponse })
  }
  handleSurveyCommentsCancel = () => {
    if (this.state.surveyStep != 3) {
      this.props.dismissFeedbackSurvey()
    }
    localStorage.setItem(
      SHOWED_FEEDBACK_SURVEY,
      !(localStorage.getItem(SHOWED_FEEDBACK_SURVEY) === "true")
    ),
      this.setState({ ...this.state, surveyVisible: false })
  }
  render() {
    const {
      loading_profile,
      profile_leader,
      dashboard,
      loading_dashboard,
      pending_surveys,
    } = this.props

    if (loading_profile || loading_dashboard) {
      return (
        <div className="loadingSpin">
          <Spin size="large" />
        </div>
      )
    }

    return (
      <Layout>
        <Helmet>
          <title>Dashboard</title>
          <meta name="description" content="Description of HomePage" />
        </Helmet>
        <Modal
          centered
          visible={this.state.surveyVisible}
          footer={null}
          width={620}
          onCancel={this.handleSurveyCommentsCancel}>
          {this.state.surveyStep == 1 && (
            <>
              <div className="survey-feedback">
                <div className="title">
                  ¿Qué tan satisfecho te encuentras con el producto?*
                </div>
                <div className="container-button">
                  <div
                    className="button-qualify"
                    onClick={() => this.saveSurveyScore(0)}>
                    0
                  </div>
                  <div
                    className="button-qualify"
                    onClick={() => this.saveSurveyScore(1)}>
                    1
                  </div>
                  <div
                    className="button-qualify"
                    onClick={() => this.saveSurveyScore(2)}>
                    2
                  </div>
                  <div
                    className="button-qualify"
                    onClick={() => this.saveSurveyScore(3)}>
                    3
                  </div>
                  <div
                    className="button-qualify"
                    onClick={() => this.saveSurveyScore(4)}>
                    4
                  </div>
                  <div
                    className="button-qualify"
                    onClick={() => this.saveSurveyScore(5)}>
                    5
                  </div>
                  <div
                    className="button-qualify"
                    onClick={() => this.saveSurveyScore(6)}>
                    6
                  </div>
                  <div
                    className="button-qualify"
                    onClick={() => this.saveSurveyScore(7)}>
                    7
                  </div>
                  <div
                    className="button-qualify"
                    onClick={() => this.saveSurveyScore(8)}>
                    8
                  </div>
                  <div
                    className="button-qualify"
                    onClick={() => this.saveSurveyScore(9)}>
                    9
                  </div>
                  <div
                    className="button-qualify"
                    onClick={() => this.saveSurveyScore(10)}>
                    10
                  </div>
                </div>
              </div>
            </>
          )}
          {this.state.surveyStep == 2 && (
            <>
              <div className="survey-feedback">
                <div className="title">¿Qué podríamos hacer para mejorar?</div>
                <TextArea
                  rows={3}
                  placeholder="Nos encantaría escuchar tus sugerencias..."
                  onChange={this.handleSurveyCommentsChange}
                />
                <br />
                <br />
                <Row justify="space-between">
                  <Button width={100} onClick={() => this.changeSurveyStep(1)}>
                    {" "}
                    &lt;&nbsp;Anterior
                  </Button>
                  <Button
                    width={100}
                    type="primary"
                    onClick={() => {
                      this.props.submitFeedbackSurvey(this.state.surveyResponse)
                      this.changeSurveyStep(3)
                    }}>
                    {" "}
                    &nbsp;&nbsp;&nbsp;Enviar&nbsp;&nbsp;&nbsp;{" "}
                  </Button>
                </Row>
              </div>
            </>
          )}
          {this.state.surveyStep == 3 && (
            <>
              <div className="survey-feedback">
                <br></br>
                <div
                  className="title"
                  style={{
                    width: "100%",
                    textAlign: "center",
                    paddingLeft: "25px",
                  }}>
                  ¡Gracias por el feedback 💙!
                </div>
              </div>
            </>
          )}
        </Modal>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            margin: "12px 2rem 32px",
          }}
          className="Dashboard DashboardLeader">
          <div
            className="Dashboard-columns"
            style={{
              gridTemplateColumns: this.emptyState().type === 1 ? "auto" : null,
            }}>
            <div className="Dashboard-columns-left">
              <div className="Dashboard-columns-left-header">
                <div className="Dashboard-columns-left-header-block">
                  <h1>
                    {this.intl.generalView.greeting}{" "}
                    {get(profile_leader, "leader.first_name", "")}! 👋🏼{" "}
                  </h1>
                  <p>{this.intl.generalView.leaderDescription}</p>
                </div>

                {pending_surveys.length > 0 && (
                  <PendingSurveys surveys={pending_surveys} />
                )}

                {get(profile_leader, "team_leader", [])
                  .filter(
                    (e) =>
                      e.date_birth_2 === true &&
                      !JSON.parse(LOCAL_DASHBOARD_BIRTHDAY_CHECK()).includes(
                        e.id_employee
                      )
                  )
                  .map((cb, ci) => (
                    <CardBirthDay
                      key={`card-birthday-${ci}`}
                      data={{
                        avatar: cb.profile_picture,
                        id: cb.id_employee,
                        name: `${cb.first_name} ${cb.last_name}`,
                      }}
                    />
                  ))}
              </div>
              {this.emptyState().active ? (
                this.emptyState().content
              ) : (
                <Fragment>
                  <div className="Dashboard-columns-left-content">
                    <div className="Dashboard-columns-left-content-block">
                      <div className="Dashboard-columns-left-content-block-title">
                        <img src={iconBars} />
                        {this.intl.generalView.results}
                      </div>
                      <div style={{ display: "grid", gridGap: 20 }}>
                        {get(dashboard, "measure_with_measure_metrics", []).map(
                          (measure, si) => (
                            <div
                              key={si}
                              style={{ display: "grid", gridGap: 15 }}>
                              <h3>
                                {measure.name}{" "}
                                <span
                                  className="color-gray-low"
                                  style={{ fontWeight: 400, fontSize: 13 }}>
                                  {" "}
                                  -{" "}
                                  {measure.metric_total_label ||
                                    this.intl.generalView.leadership}
                                </span>
                              </h3>
                              <div className="Dashboard-columns-left-content-block-widgets">
                                {[5].includes(measure.id_measure_status) &&
                                  measure.anonymity && (
                                    <div
                                      style={{ cursor: "pointer" }}
                                      onClick={() => {
                                        if (measure.survey_type === 2) {
                                          this.props.history.push(
                                            `/reports/measure/${measure.survey_type}/${measure.id_measure}`
                                          )
                                        }
                                      }}>
                                      <WidgetResumen
                                        className="WidgetResumenComponent boxShadow"
                                        title={
                                          measure.survey_type === 2 ? (
                                            <b>
                                              {measure.metric_total_label ||
                                                "Liderazgo"}
                                            </b>
                                          ) : (
                                            <span
                                              style={{ fontWeight: "normal" }}>
                                              <b>
                                                {" "}
                                                {measure.metric_total_label ||
                                                  "Clima laboral:"}
                                              </b>
                                            </span>
                                          )
                                        }
                                        isLoading={false}
                                        data={{
                                          value_visible: measure.value_visible,
                                          color: measure.color,
                                          percent: measure.value,
                                          value_org: measure.value_org,
                                          employees: measure.employees,
                                          calculate_comparative: {
                                            show: measure.variation != "",
                                            value: `${measure.variation}%`,
                                            level: !(measure.variation < 0),
                                          },
                                        }}
                                      />
                                    </div>
                                  )}
                                {this.renderWidgetResponse(measure)}
                              </div>
                            </div>
                          )
                        )}
                      </div>
                    </div>
                  </div>
                </Fragment>
              )}
            </div>
            <div
              className="Dashboard-columns-right"
              style={{ borderLeft: this.emptyState().type === 1 ? "0" : null }}>
              {get(profile_leader, "team_leader", []).length > 0 && (
                <UserList
                  hideLine
                  className="Dashboard-columns-right-team"
                  title={
                    <>
                      {this.intl.generalView.team}{" "}
                      <span>
                        ({get(profile_leader, "team_leader", []).length})
                      </span>
                    </>
                  }
                  list={get(profile_leader, "team_leader", [])}
                />
              )}
            </div>
          </div>
        </div>
      </Layout>
    )
  }
}

const mapStateToProps = createStructuredSelector({
  loading_profile: makeSelectIsLoadingProfile(),
  profile_leader: makeSelectProfileLeader(),
  loading_dashboard: makeSelectLoadingDashboard(),
  dashboard: makeSelectDashboardData(),
  pending_surveys: makeSelectPendingSurveys(),
})

function mapDispatchToProps(dispatch) {
  return {
    getProfileLeader: () => dispatch(getProfileLeaderWatcher()),
    getDashboard: () => dispatch(getDashboardWatcher()),
    getTask: () => dispatch(getTaskWatcher()),
    submitFeedbackSurvey: (params) => dispatch(submitFeedbackSurvey(params)),
    dismissFeedbackSurvey: (params) => dispatch(dismissFeedbackSurvey(params)),
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

const withReducer = injectReducer({ key: "dashboard-leader", reducer })
const withSaga = injectSaga({ key: "dashboard-leader", saga })

export default compose(withReducer, withSaga, withConnect)(Dashboard)
